// METIS Hub wording — namespace "labels" (ko), 40 keys.
// Extracted once from the approved mockup (poc-plan/mockup-src: js/i18n.js App.labels (label dictionary, plan 9.2)).
// From now on this file is the source: edit it by hand (keep ko/en keys in pairs — packages/i18n tests check
// key parity, Hangul in English text and the plan 9.1.3 wording rules). Placeholders: {name}, plural {n|one|other}.
const labels: Record<string, string> = {
  "label.conversation": "대화",
  "label.prompt": "질문",
  "label.aiAnswer": "AI 답변",
  "label.contentText": "질문·답변 글",
  "label.usage": "사용량(토큰)",
  "label.inputTokens": "새로 읽음",
  "label.cacheRead": "캐시에서 읽음",
  "label.cacheWrite": "캐시에 저장",
  "label.outputTokens": "AI가 쓴 양",
  "label.reasoningTokens": "생각에 쓴 양(쓴 양에 포함)",
  "label.model": "AI 모델",
  "label.effort": "생각 깊이",
  "label.activeTime": "AI 사용 시간",
  "label.sessionDuration": "대화가 열려 있던 시간",
  "label.latency": "응답 대기",
  "label.latencyTypical": "보통",
  "label.latencySlow": "느릴 때",
  "label.toolCall": "AI가 한 작업",
  "label.filesOpened": "AI가 열어 본 파일",
  "label.filesEdited": "고친 파일",
  "label.diff": "바뀐 내용",
  "label.toolDecision": "허용·거절",
  "label.usageMethod": "사용 방식",
  "label.methodCli": "CLI 도구",
  "label.methodApi": "API 키 호출",
  "label.entrypoint": "실행 위치",
  "label.recordingLevel": "기록 수준",
  "label.viewScope": "보기 범위",
  "label.auditLog": "열람·변경 이력",
  "label.collectionStatus": "수집 상태",
  "label.connect": "도구 연결",
  "label.quiet": "한동안 조용함",
  "label.estimatedCost": "추정 비용(청구서 아님)",
  "label.roleAdmin": "관리자",
  "label.roleManager": "매니저(팀 관리)",
  "label.roleMember": "일반 사용자",
  "label.contentReviewer": "원문 열람 담당",
  "label.logReviewer": "감사 기록 검토자",
  "label.noRecord": "기록 없음",
  "label.partial": "일부만",
};

export default labels;
